// Full trimmed rejection text, or a short fallback when the message is missing.
// Matches the login banner: typeof message === 'string', then trim, then fallback.
export function rejectionMessage(error: unknown, fallback: string): string {
    const message =
        error && typeof (error as { message?: unknown }).message === 'string'
            ? (error as { message: string }).message.trim()
            : '';
    return message || fallback;
}
